export function isConditionMet(getValues, condition) {
    if (typeof condition.isShown === 'boolean') {
        return condition.isShown === Object.hasOwn(getValues(), condition.refKey);
    } else {
        const value = getValues(condition.refKey);
        if (condition.valuePath && value !== null && typeof value === 'object') {
            const conditionObject = value;
            return conditionObject && (conditionObject[condition.valuePath] == condition.value || conditionObject === condition.value);
        } else {
            return value == condition.value;
        }
    }
}
